import { render, staticRenderFns } from "./UploadFromPdfIndexComponent.vue?vue&type=template&id=688e57cc"
import script from "./UploadFromPdfIndexComponent.vue?vue&type=script&lang=js"
export * from "./UploadFromPdfIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports